<!-- 三证考试 home页面 -->
<template>
<div class="special-topic-home">
    <div class="nav">
        <div class="nav-content">
            <div class="logo-handle">
                <img class="logo" :src="require('@/common/images/header/new_logo1.png')"/>
                <el-dropdown @command="handleChangeExam" placement="bottom">
                    <div class="handle-exam pointer">
                        <div class="examname" v-if="examinfo.examcode">{{ examinfo.shortname }}</div>
                        <img class="handle-icon" v-if="$route.name === 'SpecialTopic' || $route.name === 'SpecialChoose' || $route.name === 'SpecialTopicDetails'" :src="require('@/common/images/specialTopic/change_icon.png')" title="切换" />
                    </div>
                    <el-dropdown-menu slot="dropdown" class="exam-item-menu">
                        <el-dropdown-item :class="{active: examinfo.examcode === 'jjcy'}" command="jjcy">
                            基金从业
                        </el-dropdown-item>
                        <el-dropdown-item :class="{active: examinfo.examcode === 'zqcy'}" command="zqcy">
                            证券从业
                        </el-dropdown-item>
                        <el-dropdown-item :class="{active: examinfo.examcode === 'qhcy'}" command="qhcy">
                            期货从业
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
            <div class="menu-login">
                <div class="menu-item-box">
                    <div class="menu-item pointer" :class="{active: $route.name === 'SpecialChoose' ||　$route.name === 'SpecialChoose' || $route.name === 'SpecialTopicDetails'}" @click="handleGoSpecialTopicIndex">首页</div>
                    <div class="menu-item pointer" :class="{active: $route.name === 'SpecialTopic'}" @click="handleGoSpecialTopic">题库</div>
                    <div class="menu-item">小程序</div>
                </div>
                <div class="login-info tc-new-gray" v-if="!user.loginToken">
                    <img :src="require('@/common/images/header/user_icon.png')" alt="" @click="handleLogin" class="vm-logourl pointer">
                </div>
                <el-dropdown class="login-info" v-else placement="bottom" @command="handleLoginDropdown">
                    <span class="el-dropdown-link">
                        <img :src="user.logourl" alt="" class="vm-logourl pointer">
                    </span>
                    <el-dropdown-menu slot="dropdown" class="login-handle-dropdown">
                        <el-dropdown-item disabled>{{user.nickname}}</el-dropdown-item>
                        <el-dropdown-item><a :href="(httpName)+'://my.'+(domainName)+'/personalCenter/ClassScheduleCard?token='+ user.loginToken" class="tc-new-gray hover">用户中心</a></el-dropdown-item>
                        <el-dropdown-item command="exitlogin">退出登录</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
    </div>
    <el-scrollbar class="special-topic-content" ref="specialTopicContent">
        <router-view></router-view>
    </el-scrollbar>
    <loading v-show="loading"></loading>
    <LogAndReg ref="logAndReg" v-show="loginPop"></LogAndReg>
</div>
</template>

<script>
import specialTopic from '@/common/js/specialTopic.json'
import {mapGetters, mapActions} from 'vuex'
import Loading from "base/loading/loading"
import LogAndReg from "views/pc/login/LogAndReg"
export default {
    data() {
        return {
            examinfo: {
                examcode: 'jjcy',
                examname: '基金从业题库',
                shortname: '基金从业'
            },
            domainName:'capwhale.com',
            httpName:"https",
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {
        
    },
    methods: {
        handleLoginDropdown(command) {
            if (command === 'exitlogin') {
                this.handleExitLogin()
            }
        },
        handleChangeExam(command) {
            if (this.$route.params.examcode !== command) {
                let index = ''
                specialTopic.exam.some((item, i) => {
                    if (item.examcode === command) {
                        index = i
                        return true
                    }
                })
                this.examinfo = JSON.parse(JSON.stringify(specialTopic.exam[index]))
                this.$router.push({
                    name: this.$route.name,
                    params: {
                        examcode: command
                    }
                })
            }
        },
        // 登录、注册弹窗
        handleLogin() {
            this.setLoginPop(true)
        },
        // 退出登录
        handleExitLogin() {
            window.sessionStorage.clear()
            let user = {
                innerid: '',
                loginToken: '',
                loginname: '',
                logourl: '',
                mobile: '',
                name: '',
                nickname: '',
                isLogin: false
            }
            this.setUser(user)
            this._delCookie('token')
            this.$message.success('退出成功！')
        },
        handleGoSpecialTopicIndex() {
            if (this.$route.name !== 'SpecialChoose') {
                this.$router.push({
                    name: 'SpecialChoose',
                    query: {
                        examcode: this.examinfo.examcode
                    }
                })
            }
        },
        handleGoSpecialTopic() {
            if (this.$route.name !== 'SpecialTopic') {
                this.$router.push({
                    name: 'SpecialTopic',
                    params: {
                        examcode: this.examinfo.examcode ? this.examinfo.examcode : 'jjcy'
                    }
                })
            }
        },
        _setCookie(key, value, expiredays) {
            let exdate = new Date();
            exdate.setDate(exdate.getDate() + expiredays);
            document.cookie = key + '=' + value
            + ((expiredays == null) ? '' : ';expires=' + exdate.toGMTString())
            + ';path=/'
            + ';domain=' + window.location.hostname.split('.').slice(-2).join('.');
        },
        _delCookie(key) {
            this._setCookie(key, "", -1);
        },
        ...mapActions([
            'setLoading',
            'setLoginPop',
            'setUser'
        ])
    },
    computed: {
        ...mapGetters(
            ['user', 'domainlist','domainInfo', 'loading', 'loginPop']
        )
    },
    components: {
        Loading,
        LogAndReg
    },
    watch: {
        '$route.query': {
            handler(newV) {
                if (newV.examcode || this.$route.params.examcode) {
                    let index = ''
                    specialTopic.exam.some((item, i) => {
                        if (item.examcode === this.$route.params.examcode || item.examcode === this.$route.query.examcode) {
                            index = i
                            return true
                        }
                    })
                    this.examinfo = JSON.parse(JSON.stringify(specialTopic.exam[index]))
                } else {
                    this.examinfo = {
                        examcode: 'jjcy',
                        examname: '基金从业题库',
                        shortname: '基金从业'
                    }
                }
            },
            deep: true,
            immediate: true
        },
        '$route.params': {
            handler(newV) {
                if (newV.examcode || this.$route.query.examcode) {
                    let index = ''
                    specialTopic.exam.some((item, i) => {
                        if (item.examcode === this.$route.params.examcode || item.examcode === this.$route.query.examcode) {
                            index = i
                            return true
                        }
                    })
                    this.examinfo = JSON.parse(JSON.stringify(specialTopic.exam[index]))
                } else {
                    this.examinfo = {
                        examcode: 'jjcy',
                        examname: '基金从业题库',
                        shortname: '基金从业'
                    }
                }
            },
            deep: true,
            immediate: true
        },
        '$route.name': {
            handler(newV) {
                this.$refs.specialTopicContent.wrap.scrollTop = 0
            },
            deep: true
        }
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
// html {
//     overflow: hidden;
// }
.special-topic-home {
    height: 100vh;
    background: #F0F2F5;
    .container {
        width: 1200px;
        margin: 0 auto;
    }
    .nav {
        height: 60px;
        background: #FFFFFF;
        box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.15);
        position: relative;
        z-index: 10;
        .nav-content {
            display: flex;
            align-items: center;
            justify-content: space-between;
            height: 60px;
            max-width: 1200px;
            width: 100vw;
            margin: 0 auto;
            .logo-handle {
                display: flex;
                align-items: center;
                .logo {
                    width: 120px;
                    height: 32px;
                    margin-right: 34px;
                }
                .handle-exam {
                    display: flex;
                    align-items: center;
                    .examname {
                        font-size: 16px;
                        color: #333333;
                        line-height: 22px;
                        font-weight: bold;
                        margin-right: 10px;
                    }
                    .handle-icon {
                        width: 14px;
                        height: 14px;
                        cursor: pointer;
                        color: #333333;
                    }
                }
            }
            .menu-login {
                display: flex;
                align-items: center;
                .menu-item-box {
                    display: flex;
                    align-items: center;
                    .menu-item {
                        font-size: 16px;
                        color: #333333;
                        margin-right: 40px;
                        cursor: pointer;
                        &.active, &:hover {
                            color: #1D60AD;
                            font-weight: bold;
                        }
                    }
                }
                .login-info {
                    .vm-logourl {
                        width: 32px;
                        height: 32px;
                        border-radius: 50%;
                    }
                    .vm-dropdown-menu {
                        width: 150px !important;
                        padding: 15px 0 !important;
                        .tips {
                            text-align: center;
                            margin-top: 5px;
                        }
                    }
                }
            }
        }
    }
    .special-topic-content {
        height: calc(100vh - 60px);
        &>.el-scrollbar__wrap {

        }
        &>.el-scrollbar__bar.is-horizontal {
            display: none;
        }
    }
}
.login-handle-dropdown {
    .el-dropdown-menu__item {
        text-align: center;
        color: #333;
        &.is-disabled {
            color: #333;
        }
    }
}
.exam-item-menu {
    padding: 5px 0 !important;
    .el-dropdown-menu__item {
        line-height: 40px;
        font-size: 14px;
        color: #333333;
        &.active {
            color: #1D60AD;
            background: #F5F7FA;
        }
    }
}
</style>